import { render, staticRenderFns } from "./CreateProofPage.vue?vue&type=template&id=cd669f5a&scoped=true&"
import script from "./CreateProofPage.vue?vue&type=script&lang=js&"
export * from "./CreateProofPage.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./CreateProofPage.vue?vue&type=style&index=1&id=cd669f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd669f5a",
  null
  
)

export default component.exports